import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField,
	MuiThemeProvider,
	createMuiTheme,
	FormControl,
	InputLabel,
	FormHelperText
} from '@material-ui/core'
import Select from 'react-select';
import { useHistory, useParams } from 'react-router-dom'
import { deleteSailor, getSailorById, postSailor, updateSailor } from '../../../../api/sailor'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: '#F64E60'
		}
  }
})

function getEmptySailor() {
  return {
    fullName: '',
    mail: '',
    phone: '',
		password: '',
		repeatPassword: '',
  }
}

export default function EditSailorsPage() {
  const [sailor, setSailor] = useState(getEmptySailor())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const sailorId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!sailorId) {
      disableLoadingData()
      return
    }
    getSailorById(sailorId).then(res => {
      if (res.status === 200) {
        const sailor = res.data;
        delete sailor.password;
        setSailor(sailor)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get sailor.' })
      history.push('/sailors')
    })
  }, [sailorId, disableLoadingData, history])

  function saveSailor() {
    if (sailor.password !== sailor.repeatPassword) {
      alertError({ error: null, customMessage: 'Passwords do not match.' });
      return;
    }
    if (!sailorId) {
      postSailor(sailor).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: 'Saved!', customMessage: 'Sailor successfully created.' })
          history.push('/sailors')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save sailor.' })
      })
    } else {
      updateSailor(sailorId, sailor).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
          history.push('/sailors')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setSailor({ ...sailor, [element]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Edit sailor'>
        </CardHeader>
        <CardBody>
          <TextField
            id={`fullName`}
            label="Full name"
            value={sailor.fullName}
            onChange={handleChange('fullName')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`mail`}
            label="Mail"
            value={sailor.mail}
            onChange={handleChange('mail')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`phone`}
            label="Phone number"
            value={sailor.phone}
            onChange={handleChange('phone')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`licence`}
            label="Licence"
            value={sailor.licence}
            onChange={handleChange('licence')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`password`}
            label='Password'
            value={sailor.password}
            onChange={handleChange('password')}
            InputLabelProps={{
              shrink: true,
            }}
            type='password'
            margin='normal'
            variant='outlined'
            required
          />
          <TextField
            id={`repeatPassword`}
            label='Repeat password'
            value={sailor.repeatPassword}
            onChange={handleChange('repeatPassword')}
            InputLabelProps={{
              shrink: true,
            }}
            type='password'
            margin='normal'
            variant='outlined'
            required
          />
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/sailors')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>
      <Button
        onClick={() => saveSailor()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Save sailor
      </Button>
      {sailorId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Delete sailor
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'Are you sure you want to delete this sailor?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteSailor(sailorId).then(res => {
              if (res.status === 204) {
                alertSuccess({ title: 'Deleted!', customMessage: 'Sailor deleted successfully' })
                history.push('/sailors')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not delete economic sector.' })
            })
          }}
        />
      </>}
    </>
  );
}
